import React from 'react';
import { v4 as uuid } from 'uuid';

import Icon, { faTriangleExclamation } from '~components/icon';
import TooltipPortal from '~weekly-planner/components/TooltipPortal';

interface ComponentProps {
  id?: string;
  label?: string;
  showAlert?: boolean;
  color?: string;
  tooltip?: string;
  className?: string;
}

const AlertBadge: React.FC<ComponentProps> = ({
  id,
  label,
  showAlert = false,
  color = 'orange',
  tooltip,
  className = '',
}) => {
  const iconId = `${id || uuid()}_alert_icon`;

  return (
    <span className={`inline-flex items-center ${className}`}>
      {showAlert && (
        <span className="me-2">
          <Icon id={iconId} name="alert" icon={faTriangleExclamation} color={color} />
          {tooltip && <TooltipPortal targetId={iconId} content={tooltip} />}
        </span>
      )}
      {label && <span>{label}</span>}
    </span>
  );
};

export default AlertBadge;
